/**
 * Client environment detection utilities.
 * Shared by logger and metrics for consistent browser/platform reporting.
 */

export const getTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Unknown';
};

export const getBrowserInfo = (): { name: string; version: string } => {
  const ua = navigator.userAgent;
  let match: RegExpMatchArray | null;
  if ((match = ua.match(/Edg\/(\d+(?:\.\d+)?)/))) return { name: 'Edge', version: match[1] };
  if ((match = ua.match(/OPR\/(\d+(?:\.\d+)?)/))) return { name: 'Opera', version: match[1] };
  if ((match = ua.match(/Chrome\/(\d+(?:\.\d+)?)/))) return { name: 'Chrome', version: match[1] };
  if ((match = ua.match(/Firefox\/(\d+(?:\.\d+)?)/))) return { name: 'Firefox', version: match[1] };
  if ((match = ua.match(/Version\/(\d+(?:\.\d+)?).*Safari/))) return { name: 'Safari', version: match[1] };
  return { name: 'Unknown', version: 'Unknown' };
};

export const getPlatform = (): string => {
  const ua = navigator.userAgent;
  if (/Windows/.test(ua)) return 'Windows';
  if (/Macintosh/.test(ua)) return 'macOS';
  if (/iPhone|iPad/.test(ua)) return 'iOS';
  if (/Android/.test(ua)) return 'Android';
  if (/Linux/.test(ua)) return 'Linux';
  return 'Unknown';
};
